import { Phone, MessageCircle, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data/urban";

export const MobileCTA = () => {
  const waText = encodeURIComponent(`Hi Urban Renovations, I am interested in your interior and renovation services. I would like to discuss my requirement.`);
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 sm:hidden bg-black text-white grid grid-cols-3 border-t border-white/10">
      <a href={`tel:${BRAND.phoneRaw}`} data-testid="mcta-call" className="flex flex-col items-center justify-center gap-0.5 py-3 border-r border-white/10 hover:bg-white/5">
        <Phone className="h-4 w-4" />
        <span className="text-[10px] uppercase tracking-wider font-bold">Call</span>
      </a>
      <a href={`https://wa.me/${BRAND.whatsapp}?text=${waText}`} target="_blank" rel="noopener noreferrer" data-testid="mcta-whatsapp" className="flex flex-col items-center justify-center gap-0.5 py-3 border-r border-white/10 hover:bg-white/5">
        <MessageCircle className="h-4 w-4" />
        <span className="text-[10px] uppercase tracking-wider font-bold">WhatsApp</span>
      </a>
      <Link to="/contact" data-testid="mcta-quote" className="flex flex-col items-center justify-center gap-0.5 py-3 hover:bg-white/5">
        <FileText className="h-4 w-4" />
        <span className="text-[10px] uppercase tracking-wider font-bold">Get Quote</span>
      </Link>
    </div>
  );
};
